<template>
  <AppCard>
    <h2 class="mb-4">
      {{ $t(`${translationPrefix}.reasons.${reason}.title`) }}
    </h2>

    <template v-if="reason === 'autopay'">
      <i18n-t :keypath="`${translationPrefix}.reasons.autopay.text`"
              tag="p"
              scope="global"
      >
        <template #goCardLessLink>
          <a :href="goCardLessUrl" target="_blank" class="brand-link">
            {{ $t(`${translationPrefix}.goCardLessLink.autopay`) }}
          </a>
        </template>

        <template #contactSupport>
          <i18n-t :keypath="`${translationPrefix}.contactSupport.text`"
                  tag="p"
                  scope="global"
          >
            <template #byEmail>
              <i18n-t :keypath="`${translationPrefix}.contactSupport.byEmail`"
                      tag="p"
                      scope="global"
              >
                <template #email>
                  <a
                    :href="`mailto:${supportEmail}`"
                    target="_blank"
                    class="brand-link"
                    rel="noopener"
                  >
                    {{ supportEmail }}
                  </a>
                </template>
              </i18n-t>
            </template>
            <template #byPhone>
              <p>{{ $t(`${translationPrefix}.contactSupport.byPhone`) }}</p>
            </template>
          </i18n-t>
        </template>
      </i18n-t>
    </template>
    <template v-else-if="reason === 'disabled'">
      <i18n-t :keypath="`${translationPrefix}.reasons.disabled.text`"
              tag="p"
              scope="global"
      >
        <template #contactSupport>
          <i18n-t :keypath="`${translationPrefix}.contactSupport.byEmail`"
                  tag="p"
                  scope="global"
          >
            <template #email>
              <a
                :href="`mailto:${supportEmail}`"
                target="_blank"
                class="brand-link"
                rel="noopener"
              >
                {{ supportEmail }}
              </a>
            </template>
          </i18n-t>
          <p>{{ $t(`${translationPrefix}.contactSupport.byPhone`) }}</p>
        </template>
      </i18n-t>
    </template>
    <template v-else-if="reason === 'trial'">
      <i18n-t :keypath="`${translationPrefix}.reasons.trial.text`"
              tag="p"
              scope="global"
      >
        <template #contactSupport>
          <i18n-t :keypath="`${translationPrefix}.contactSupport.byEmail`"
                  tag="p"
                  scope="global"
          >
            <template #email>
              <a
                :href="`mailto:${supportEmail}`"
                target="_blank"
                class="brand-link"
                rel="noopener"
              >
                {{ supportEmail }}
              </a>
            </template>
          </i18n-t>
          <p>{{ $t(`${translationPrefix}.contactSupport.byPhone`) }}</p>
        </template>
      </i18n-t>
    </template>
    <template v-else-if="reason === 'unpaid'">
      <i18n-t :keypath="`${translationPrefix}.reasons.unpaid.text`"
              tag="p"
              scope="global"
      >
        <template #goCardLessLink>
          <a :href="goCardLessUrl" target="_blank" class="brand-link">
            {{ $t(`${translationPrefix}.goCardLessLink.unpaid`) }}
          </a>
        </template>

        <template #contactSupport>
          <i18n-t :keypath="`${translationPrefix}.contactSupport.text`"
                  tag="p"
                  scope="global"
          >
            <template #byEmail>
              <i18n-t :keypath="`${translationPrefix}.contactSupport.byEmail`"
                      tag="p"
                      scope="global"
              >
                <template #email>
                  <a
                    :href="`mailto:${supportEmail}`"
                    target="_blank"
                    class="brand-link"
                    rel="noopener"
                  >
                    {{ supportEmail }}
                  </a>
                </template>
              </i18n-t>
            </template>
            <template #byPhone>
              <p>{{ $t(`${translationPrefix}.contactSupport.byPhone`) }}</p>
            </template>
          </i18n-t>
        </template>
      </i18n-t>
    </template>

    <p class="mt-4">{{ $t(`${translationPrefix}.seeYouSoon`) }}</p>

    <p>{{ $t(`${translationPrefix}.closdTeam`) }}</p>

    <div class="text-center">
      <AppButton text to="/">
        {{ $t(`${translationPrefix}.backToHome`) }}
      </AppButton>
    </div>
  </AppCard>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AppCard from '@/common/AppCard.vue'
import AppButton from '@/common/buttons/AppButton.vue'

type PossibleSubscriptionDisableReason = 'autopay' | 'disabled' | 'trial' | 'unpaid'

export default defineComponent({
  name: 'SubscriptionDisableReasonsCard',
  components: { AppButton, AppCard },
  props: {
    reason: {
      type: String as PropType<PossibleSubscriptionDisableReason>,
      required: true,
    },
  },
  data () {
    return {
      goCardLessUrl: 'https://pay.gocardless.com/AL00031K3ZT0G2',
      supportEmail: 'support@closd.com',
      translationPrefix: 'subscriptions.SubscriptionDisableReasonsCard',
    }
  },
})
</script>

<style scoped>
a.brand-link {
  color: rgb(var(--v-theme-brand));
}
</style>
